module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/b77bd40e28ea6776c9c2b7f365b16cd8.png";